module.exports = __webpack_public_path__ + "media/packs/images/flags/LR-54a08a8d728074a87e9e15656accb57c.svg";